import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const CRMDashboard = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default CRMDashboard